import React from 'react';
import {navigate} from '@reach/router';
import NoWorkspaceAccessPage from 'components/NoWorkspaceAccessPage';
import {useUser} from 'containers/UserApp/providers/UserProvider';
import WorkspaceCreatorPage from './components/WorkspaceCreatorPage';
import useCreateWorkspaceMutation from './hooks/useCreateWorkspaceMutation';

function WorkspaceCreator () {
  const {user} = useUser();
  const [createWorkspace, {
    data,
    error,
    loading,
  }] = useCreateWorkspaceMutation();

  const onSubmit = async ({
    name, urlName,
  }) => createWorkspace({
    variables: {
      name, urlName,
    },
  });

  if (data && !loading) {
    navigate('/workspaces');
  }

  // SSO users must be added to their organization’s workspace by an admin.
  if (user.loggedInWithSSOProviderId) {
    return <NoWorkspaceAccessPage />;
  }

  return <WorkspaceCreatorPage
    createWorkspace={onSubmit}
    error={error}
    loading={!data && loading}
  />;
}

export default WorkspaceCreator;
